module.exports = __webpack_public_path__ + "static/media/success.7006df54.svg";